import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        tasklist: '='
    },
    template: `
        <user-tasklist-form tasklist="vm.tasklist" is-add="vm.isAdd"/>`
})
export default class {
    $onInit () {
        this.isAdd = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/tasklist/edit/index.js